import { render } from "./BaseSelectBox.vue?vue&type=template&id=82b540e6&scoped=true"
import script from "./BaseSelectBox.vue?vue&type=script&lang=js"
export * from "./BaseSelectBox.vue?vue&type=script&lang=js"

import "./BaseSelectBox.vue?vue&type=style&index=0&id=82b540e6&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82b540e6"]])

export default __exports__